import React, { Component, lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid } from 'react-md';
import { withRouter, Redirect } from 'react-router-dom';
import { fromJS } from 'immutable';
import { isEqual, isEmpty, find, get } from 'lodash-es';
import PropTypes from 'prop-types';
import { withSnackbar } from 'notistack';

import * as surveysActions from '../../Services/Surveys/actions';
import * as systemActions from '../../Services/System/actions';
import * as quotationsActions from '../../Services/Quotations/actions';
import * as productsActions from '../../Services/Products/actions';

// import WizardForm from './WizardForm';
import { showAlerts } from '../Common/utils';
import { stringifyQuery, parseQuery } from '../../Utils/Utils';

import './NewSurvey.scss';

const WizardForm = lazy(() => import('./WizardForm'));

class NewSurveySR extends Component {
  constructor(props) {
    super(props);

    this.state = {
      survey: undefined,
    };
  }

  componentDidMount() {
    const { actions, surveys, system, location, history, commercialproducts, dateFormat } = this.props;
    const icons = system.getIn(['icons']) ? system.getIn(['icons']) : fromJS({});
    if (surveys && surveys.size === 0) {
      actions.fetchSurveys();
    }
    if (icons && icons.size === 0) {
      actions.fetchIcons();
    }

    if (Array.isArray(commercialproducts) && commercialproducts.length === 0) {
      actions.fetchCommercialProductsV2({ date: new Date(), dateFormat });
    }
    // survey
    const params = isEmpty(parseQuery(location.search)) ? {} : parseQuery(location.search);
    this.setState({ ...params });
    history.push({
      pathname: location.pathname,
      search: stringifyQuery(params),
    });
    this.handleSelectSurvey(params.survey);
  }

  componentDidUpdate(prevProps) {
    const { alerts: prevAlerts, loading: prevLoading } = prevProps;
    const { alerts, loading, enqueueSnackbar } = this.props;
    if (!isEqual(prevLoading, loading) && !isEqual(prevAlerts, alerts)) {
      showAlerts({ enqueueSnackbar, alerts });
    }
  }

  handleSubmitSurvey = params => {
    const { actions, location, history } = this.props;
    const { id, idPart, payload } = params;
    actions.submitSurveyForm({ id, idPart, payload });
    this.setState({ data: payload });
    const search = { ...parseQuery(location.search), data: payload };
    history.push({
      pathname: location.pathname,
      search: stringifyQuery(search),
    });
  };

  handleSelectSurvey = id => {
    const { location, history } = this.props;
    // if (typeof id !== 'undefined') {
    //   const { actions } = this.props;
    //   actions.fetchSurvey({ id });
    // }
    // survey
    let params = parseQuery(location.search);
    this.setState({ survey: id, data: params.survey === id ? params.data : undefined });
    params = params.survey === id ? { ...params, survey: id } : { survey: id };
    const strParams = stringifyQuery(params);
    history.push({
      pathname: location.pathname,
      search: strParams,
    });
    location.search = `?${strParams}`;
  };

  handleFetchSurveys = () => {
    const { actions } = this.props;
    actions.fetchSurveys();
  };

  handleSelectProduct = ({ product, date }) => {
    if (product !== 'undefined') {
      const { actions, dateFormat, commercialproducts } = this.props;
      const commercialproduct = find(commercialproducts, { value: product });
      actions.fetchNewQuotationSR({
        value: commercialproduct.product,
        date,
        dateFormat,
        commercialproduct,
      });
    }
  };

  render() {
    const {
      pageTitle,
      defaultPageTitle,
      canonical,
      surveys,
      strings,
      loading,
      system,
      redirect,
      quotationID,
      location,
      locale,
    } = this.props;
    const to = {
      pathname: `/quotations/${quotationID}`,
      state: { from: location },
    };

    if (redirect) {
      return <Redirect push to={to} preserveQueryString={false} />;
    }

    const { survey, data } = this.state;
    const { isLoadingSurveys } = loading;
    const icons = system.getIn(['icons']);
    const fallback = <div>loading...</div>;
    const helmet = (
      <Helmet>
        <meta charSet="utf-8" />
        <title>{strings[pageTitle] || defaultPageTitle}</title>
        <meta name="description" content={strings[pageTitle] || defaultPageTitle} />
        <link rel="canonical" href={canonical} />
      </Helmet>
    );
    return (
      <div className="coog-app survey">
        {helmet}
        <h1 className="md-title md-cell md-cell--12">{strings[pageTitle] || defaultPageTitle}</h1>
        <Grid className="coog-grid">
          {isLoadingSurveys ? (
            'loading...'
          ) : (
            <Suspense fallback={fallback}>
              <WizardForm
                surveys={surveys}
                icons={icons}
                survey={survey}
                selectSurvey={this.handleSelectSurvey} // step 1
                submitSurvey={this.handleSubmitSurvey} // step 2
                selectProduct={this.handleSelectProduct} // step 3
                strings={strings}
                initialValues={data}
                locale={locale}
              />
            </Suspense>
          )}
        </Grid>
      </div>
    );
  }
}

NewSurveySR.propTypes = {
  // eslint-disable-next-line
  location: PropTypes.object.isRequired,
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  actions: PropTypes.shape({
    fetchSurveys: PropTypes.func,
    fetchSurvey: PropTypes.func,
    submitSurveyForm: PropTypes.func,
    fetchIcons: PropTypes.func,
    fetchCommercialProductsV2: PropTypes.func,
    fetchNewQuotationSR: PropTypes.func,
  }).isRequired,
  pageTitle: PropTypes.string,
  defaultPageTitle: PropTypes.string,
  canonical: PropTypes.string,
  locale: PropTypes.string,
  dateFormat: PropTypes.string.isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  surveys: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  loading: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  system: PropTypes.object,
  enqueueSnackbar: PropTypes.func.isRequired,
  alerts: PropTypes.object, // eslint-disable-line
  commercialproducts: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    })
  ),
  redirect: PropTypes.bool,
  quotationID: PropTypes.string,
};

NewSurveySR.defaultProps = {
  pageTitle: 'title.survey.create',
  defaultPageTitle: 'Sélectionner votre besoin',
  canonical: 'http://www.coopengo.com/',
  surveys: fromJS({}),
  loading: fromJS({}),
  strings: {},
  locale: 'fr',
  system: fromJS({}),
  commercialproducts: [],
  alerts: {},
  redirect: false,
  quotationID: undefined,
};
// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => {
  const surveys = state.getIn(['surveys', 'map']) ? state.getIn(['surveys', 'map']) : fromJS({});
  const strings = state.getIn(['surveys']).toJS().strings
  const locale = state.getIn(['system', 'i18n', 'lang'], 'fr');
  const dateFormat = state.getIn(['system', 'dateFormat']) ? state.getIn(['system', 'dateFormat']) : 'YYYY-MM-DD';
  const commercialproducts = state.getIn(['products', 'commercialproductsV2'])
    ? state
        .getIn(['products', 'commercialproductsV2'])
        .toJS()
        .map(product => ({
          value: product.id,
          label: product.name,
          product: get(product, 'technical_product.id', undefined),
        }))
    : [];
  const { redirect, quotationID } = state.getIn(['quotations', 'current'])
    ? state.getIn(['quotations', 'current']).toJS()
    : {};

  const alerts = fromJS({}).mergeDeep(state.getIn(['surveys', 'alerts']), state.getIn(['quotations', 'alerts']));
  const loading = fromJS({}).mergeDeep(state.getIn(['surveys', 'loading']), state.getIn(['quotations', 'loading']));
  // ===
  return {
    surveys,
    loading,
    strings,
    system: state.getIn(['system']),
    alerts,
    locale,
    dateFormat,
    commercialproducts,
    redirect,
    quotationID,
  };
};
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    { ...surveysActions, ...systemActions, ...quotationsActions, ...productsActions },
    dispatch
  ),
});

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(NewSurveySR)));
